import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Home, ShieldOff } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Страница «нет доступа». Показывается вместо редиректа: пользователь должен
 * понимать, что раздел существует, но закрыт для его роли, а не гадать, почему
 * его выбросило на главную.
 */
export default function Forbidden() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[calc(100vh-5rem)] flex-col items-center justify-center px-4 py-12">
      <div className="w-full max-w-lg text-center">
        <div className="relative mx-auto mb-8 flex h-28 w-28 items-center justify-center">
          <span className="absolute inset-0 rounded-full bg-primary/10" aria-hidden />
          <span className="absolute inset-2 rounded-full bg-primary/5" aria-hidden />
          <ShieldOff className="relative h-14 w-14 text-primary" strokeWidth={1.5} aria-hidden />
        </div>

        <p className="text-7xl font-bold tracking-tight text-primary/90 tabular-nums sm:text-8xl">
          403
        </p>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
          Нет доступа
        </h1>
        <p className="mt-3 text-base leading-relaxed text-muted-foreground">
          Этот раздел закрыт для вашей роли. Если доступ нужен по работе, обратитесь
          к администратору системы.
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button asChild size="lg" className="min-w-[12rem]">
            <Link to="/home">
              <Home className="h-4 w-4" />
              На главную
            </Link>
          </Button>
          <Button
            type="button"
            variant="outline"
            size="lg"
            className="min-w-[12rem]"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-4 w-4" />
            Назад
          </Button>
        </div>
      </div>
    </div>
  );
}
